// src/routes/AuthRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import NoLayout from "../components/NoLayout";
import FinoCSPLanding from "../pages/LandingPages/FinoCSPLanding";
// import Login from '../pages/Login';
// import NotFound from '../pages/NotFound';

const AuthRoutes = (
  <Route element={<NoLayout />}>
    {/* <Route path="/login" element={<Login />} />
    <Route path="*" element={<NotFound />} /> */}
    {/* Add more auth routes here */}

    <Route path="/fino-csp-landing" element={<FinoCSPLanding />} />
  </Route>
);

export default AuthRoutes;
